import { TableBody, TableHead, TableRow } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import styled from "styled-components";
import theme from "../styles/theme";
import CompetencyModal from "./CompetencyModal";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import LoadingSpinner from "./LoadingSpinner";
import TableComponent, { StyledTableCell, StyledTableRow } from "./Table";

const Header = styled.h4`
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
type InstructorCompetencyModalProps = {
  isOpen?: boolean;
  data: any;
  semesterName: string;
  setOpen: (x: boolean) => void;
};
interface Column {
  id: "cmkl_id" | "name" | "nickname" | "email" | "assessed_skills";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "cmkl_id", label: "CMKL Id", minWidth: 90 },
  { id: "name", label: "Student first and last name", minWidth: 150 },
  {
    id: "nickname",
    label: "Student nickname",
    minWidth: 150,
  },
  {
    id: "email",
    label: "Student email",
    minWidth: 150,
  },
  {
    id: "assessed_skills",
    label: "Assessments completed",
    minWidth: 100,
  },
];
const InstructorCompetencyModal = ({
  isOpen,
  setOpen,
  data,
  semesterName,
}: InstructorCompetencyModalProps): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(false);
  const [students, setStudents] = useState<Array<any>>([]);

  console.log('data',data)
  useEffect(() => {
    fetchStudents(data.competency_code, semesterName);
  }, [data, semesterName]);
  const fetchStudents = (code: string, semester: string) => {
    setLoading(true);
    axios
      .get(
        `/instructor/competency/students?competency_code=${code}&semester_name=${semester}&university_code=CMKL&curriculum_version=${data.curriculum_version}&program_name=${data.program_name}`
      )
      .then((res) => {
        if (res.data.competency_students) {
          setStudents(res.data.competency_students);
        } else {
          setStudents([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setStudents([]);
        setLoading(false);
      });
  };
  return (
    <>
      <CompetencyModal
        customStyle={{
          overlay: {
            zIndex: "1005",
          },
          content: {
            inset: `0px 0px 0px ${theme.sidebarWidth}`,
            maxWidth: "100%",
            background: "#0B0C1F",
          },
        }}
        isOpen={isOpen || false}
        setOpen={setOpen}
      >
        <CustomFlex>
          <ClickableIcon
            size={3.125}
            fixedWidth={false}
            name="times"
            onClick={() => setOpen(false)}
          />
          <FlexGrow>
            <Header>
              {data?.competency_code} List of students enrolled
            </Header>
          </FlexGrow>
        </CustomFlex>
        <TableComponent navHeight="95px" aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                >
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                {students.length === 0 ? (
                  <>
                    <StyledTableRow role="checkbox" tabIndex={-1} key={0}>
                      <StyledTableCell colSpan={5} key={1} align="center">
                        No enrolled students for the selected competency
                      </StyledTableCell>
                    </StyledTableRow>
                  </>
                ) : (
                  <>
                    {students.map((row, index) => {
                      return (
                        <StyledTableRow
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                        >
                          {columns.map((column) => {
                            let value = "";
                            if (column.id === "name") {
                              value = row.first_name + " " + row.last_name;
                            } else if (column.id === "assessed_skills") {
                              value =
                                row.assessed_skills + "/" + row.total_skills;
                            } else {
                              value = row[column.id];
                            }
                            return (
                              <StyledTableCell
                                key={column.id}
                                align={column.align}
                              >
                                {value}
                              </StyledTableCell>
                            );
                          })}
                        </StyledTableRow>
                      );
                    })}
                  </>
                )}
              </>
            )}
          </TableBody>
        </TableComponent>
      </CompetencyModal>
    </>
  );
};

export default InstructorCompetencyModal;
